import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

const DisplayStateProvider: React.FC<{ children: React.ReactNode }> = (
  props
) => {
  const { children } = props;
  const location = useLocation();

  useEffect(() => {
    const html = document.querySelector('html');
    if (!html) return;
    if (location.pathname.endsWith('/monitor')) {
      html.classList.add('monitor-mode');
    } else {
      html.classList.remove('monitor-mode');
    }
  }, [location.pathname]);

  return children;
};

DisplayStateProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DisplayStateProvider;
